<template>
  <div>
    <div class="plan-header">
      <div class="left-title" v-text="$t('user.title')"></div>
    </div>
    <div class="content-body">
      <div class="xinxi">
        <div class="title" v-text="$t('user.default_title1')"></div>
        <div class="line-list">
          <div class="left-title" v-text="$t('user.line1')"></div>
          <div class="right-title"><el-input :value="user_info.rand_id" :disabled="true" size="small"></el-input></div>
        </div>
        <div class="line-list">
          <div class="left-title" v-text="$t('user.line2')"></div>
          <div class="right-title"><el-input :value="user_info.company_name" :disabled="true" size="small"></el-input></div>
        </div>
        <div class="line-list">
          <div class="left-title" v-text="$t('user.line3')"></div>
          <div class="right-title"><el-input :value="user_info.address" :disabled="true" size="small"></el-input></div>
        </div>
        <div class="line-list">
          <div class="left-title" v-text="$t('user.line4')"></div>
          <div class="right-title"><el-input :value="user_info.company_link" :disabled="true" size="small"></el-input></div>
        </div>
        <div class="line-list">
          <div class="left-title" v-text="$t('user.line5')"></div>
          <div class="right-title"><el-input :value="user_info.product_name" :disabled="true" size="small"></el-input></div>
        </div>
        <div class="line-list">
          <div class="left-title" v-text="$t('user.line6')"></div>
          <div class="right-title"><el-input :value="user_info.contact_name" :disabled="true" size="small"></el-input></div>
        </div>
        <div class="line-list">
          <div class="left-title" v-text="$t('user.line7')"></div>
          <div class="right-title"><el-input :value="user_info.phone_new" :disabled="true" size="small"></el-input></div>
        </div>
        <div class="line-list">
          <div class="left-title" v-text="$t('user.line8')"></div>
          <div class="right-title"><el-input :value="user_info.company_business_no" :disabled="true" size="small"></el-input></div>
        </div>
      </div>
      <div class="xinxi">
        <div class="title" v-text="$t('user.default_title2')"></div>
        <el-tabs v-model="activeName">
            <el-tab-pane :label="$t('user.label1')" name="first">
              <el-table :data="tableData" style="width: 100%" border>
                <el-table-column :label="$t('user.label1')">
                  <template slot-scope="scope">
                    <a :href="getImg(scope.row.url)" target="_blank"><img :src="getImg(scope.row.url)" alt="" style="width: 80px;"></a>
                  </template>
                </el-table-column>
                <el-table-column prop="company_business_no" :label="$t('user.td1')"></el-table-column>
                <el-table-column prop="business_time" :label="$t('user.td2')"></el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="$t('user.label2')" name="second">
              <el-table :data="tableData1" style="width: 100%" border>
                <el-table-column :label="$t('user.label1')">
                  <template slot-scope="scope">
                    <a :href="getImg(scope.row.url)" target="_blank"><img :src="getImg(scope.row.url)" alt="" style="width: 80px;"></a>
                  </template>
                </el-table-column>
                <el-table-column prop="business_time" :label="$t('user.td2')"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user_info: [],
      activeName: 'first',
      tableData: [],
      tableData1: []
    };
  },
  mounted() {
    this.user_info = JSON.parse(sessionStorage.getItem('user_info'));
    if (this.user_info['company_business'] !== undefined && this.user_info['company_business'].length) {
      this.tableData = [this.user_info['company_business'][0]];
      this.tableData[0]['company_business_no'] = this.user_info['company_business_no'];
      this.tableData[0]['business_time'] = this.user_info['business_time'];
      for (let i = 1; i < this.user_info['company_business'].length; i++) {
        this.tableData1.push({
          url: this.user_info['company_business'][i].url,
          business_time: this.user_info['business' + i + '_time']
        });
      }
    }
    setTimeout(() => {
      this.$function.hiddenLoading();
    }, 200);
  },
  methods: {
    getImg(img) {
      return this.$Config.apiUrl + img;
    }
  }
};
</script>
<style lang="less" scoped>
  .plan-header {
    width: calc(100% - 32px);
    padding: 0 16px;
    height: 48px;
    display: flex;
    flex-shrink: 0;
    background: #fff;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 66px;
    left: 0;
    background: #fff;
    z-index: 99;
    .left-title {
      line-height: 48px;
      font-size: 18px;
      font-weight: 500;
      color: #222;
    }
    .right-content {
      color: #666;
      font-size: 14px;
    }
  }
  .content-body {
    margin-top: 48px;
  }
  .xinxi {
    width: calc(100% - 50px);
    background: #fff;
    padding: 25px;
    .title {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #221815;
      padding: 10px 0;
      font-weight: 700;
      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }
    }
    .line-list {
      width: 100%;
      display: flex;
      margin-top: 18px;
      align-items: center;
      .left-title, .right-title {
        width: 350px;
        font-size: 14px;
        color: #221815;
      }
      .left-title {
        width: 100px;
      }
    }
    .img-lists {
      // display: flex;
      div {
        display: inline-block;
        padding-bottom: 30px;
        margin-top: 10px;
        position: relative;
        p {
          width: calc(100% - 15px);
          height: 30px;
          line-height: 30px;
          position: absolute;
          background: rgba(0, 0, 0, .5);
          color: #fff;
          bottom: 32px;
          text-align: center;
        }
      }
      img {
        width: 250px;
        margin-right: 15px;
      }
    }
  }
</style>
